/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AnnualBudgetDto } from '../../models/annual-budget-dto';

export interface GetAnnualBudget$Params {
  year: number;
}

export function getAnnualBudget(http: HttpClient, rootUrl: string, params: GetAnnualBudget$Params, context?: HttpContext): Observable<StrictHttpResponse<AnnualBudgetDto>> {
  const rb = new RequestBuilder(rootUrl, getAnnualBudget.PATH, 'get');
  if (params) {
    rb.path('year', params.year, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AnnualBudgetDto>;
    })
  );
}

getAnnualBudget.PATH = '/budget-management/{year}';
